import * as React from 'react';
import {ReactNode, useCallback, useEffect, useState} from 'react';
import "./LanguageSwitch.css";
import {ThunkDispatchType} from "../../main/reducers/IMainAppState";
import {useDispatch} from "react-redux";
import {ChangeLanguageCode} from "../../main/actions/IAppActionCreators";

export interface ILanguageSwitchProps {
    languages: string[];
    languageCode: string;
}

export default (props: ILanguageSwitchProps) => {

    const { languages, languageCode } = props;
    const dispatch: ThunkDispatchType = useDispatch();
    const handleChangeLanguage = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, languageCode: string): void => {
        e.preventDefault();

        dispatch(ChangeLanguageCode(languageCode));
    }, []);

    const [ languagesNameMap, setLanguagesNameMap ] = useState({});

    useEffect(() => {
        if(languages.length <= 1) {
            return;
        }

        (async () => {
            const languagesNameMap = {};
            await Promise.all(languages.map(async languageCode => {
                const languageImport = await import(`../../i18n/${languageCode}`);
                languagesNameMap[languageCode] = languageImport.default.__name__;
            }))
            setLanguagesNameMap(languagesNameMap);
        })();
    }, [languages]);

    let render: ReactNode;

    if(languages.length <= 1) {
        return null;
    } else if(languages.length === 2) {
        const otherLanguage = languages.find(language => language !== languageCode)!;
        render = <a href="" onClick={(e) => handleChangeLanguage(e, otherLanguage)}>{languagesNameMap[otherLanguage]}</a>;
    } else {
        return null;
    }

    return (
        <div className="text-right language-switch">
            {render}
        </div>
    )
}